interface ComparisonTableProps {
  title: string
  headers: string[]
  rows: string[][]
}

export function ComparisonTable({ title, headers, rows }: ComparisonTableProps) {
  return (
    <div className="my-10">
      <h4 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-4 flex items-center gap-2">
        <span className="w-8 h-px bg-accent-primary/50" />
        {title}
      </h4>
      <div className="overflow-x-auto rounded-lg border border-border bg-card/50">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-muted/40">
              {headers.map((header, index) => (
                <th
                  key={index}
                  className={`px-4 py-3.5 text-left font-semibold whitespace-nowrap ${
                    index === 0 ? "text-accent-primary" : "text-foreground"
                  }`}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="border-b border-border/60 last:border-0 hover:bg-muted/20 transition-colors duration-150"
              >
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={`px-4 py-3.5 ${
                      cellIndex === 0
                        ? "font-medium text-foreground/90"
                        : "text-muted-foreground leading-relaxed"
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
